<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="post-middle-container">
    <div :class="postType">
      <div
        ref="text"
        class="text"
        v-html="post.text"
      />
      <div
        v-if="showBackgroundOver"
        class="background-over-text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostMiddle',
  props: {
    post: {
      type: Object,
      required: true,
    },
    isPostWithImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showBackgroundOver: false,
      postWithImageHeight: 142,
      postWithoutImageHeight: 242,
    };
  },
  computed: {
    postType() {
      if (this.isPostWithImage) return 'post-text--image';
      return 'post-text--regular';
    },
  },
  mounted() {
    this.$nextTick(() => {
      let maxImageSize = 0;
      if (this.isPostWithImage) {
        maxImageSize = this.postWithImageHeight;
      } else {
        maxImageSize = this.postWithoutImageHeight;
      }

      if (this.$refs.text.clientHeight >= maxImageSize) {
        this.showBackgroundOver = true;
      }
    });
  },
};
</script>

<style scoped lang="scss">
  .post-middle-container {
    position: relative;
    word-break: break-word;
  }

  .post-text--image {
    max-height: 172px;
    padding: 20px;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .text {
    max-height: 500px;
    padding: 20px;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .background-over-text {
    z-index: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.1));
  }

</style>
